module.exports = __webpack_public_path__ + "media/images/chat_company_closed_account-69f9e6ba89e02229a15b9111ac662c51.svg";